import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import { 
    TextValidatorNumberRequired,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import tipoMomentoTributacaoIRList from '../../../business-rules/List/tipoMomentoTributacaoIRList'



export const TaxaCDIAnual = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="taxaCDIAnual"
            label={LABEL.taxaCDIAnual}
            value={values.taxaCDIAnual === 0 ? 0 : values.taxaCDIAnual || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
        />
    )
}

export const RetornoCDI = ({ values, handleChange }) => {
    
    return (
        <TextValidatorNumberRequired
            name="retornoCDI"
            label={LABEL.retornoCDI}
            value={values.retornoCDI === 0 ? 0 : values.retornoCDI || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxa}
            numMax={NUMMAX.taxa}
        />
    )
}

export const TaxaJurosAnual = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="taxaJurosAnual"
            label={LABEL.taxaJurosAnual}
            value={values.taxaJurosAnual === 0 ? 0 : values.taxaJurosAnual || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
            disabled={values.taxaCDIAnual || values.retornoCDI ? true : false}
        />
    )
}

export const TipoMomentoTributacaoIR = ({ values, handleChange }) => {

    return (
        <TextFieldTextSelect
            name="tipoMomentoTributacaoIR"
            label={LABEL.tipoMomentoTributacaoIR}
            value={values.tipoMomentoTributacaoIR || ''}
            onChange={handleChange}
            list={tipoMomentoTributacaoIRList}
        />
    )
}

export const PercIR = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="percIR"
            label={LABEL.percIR}
            value={values.percIR === 0 ? 0 : values.percIR || ''}
            onChange={handleChange}
            numMin={NUMMIN.percIR}
            numMax={NUMMAX.percIR}
        />
    )
}

export const TempoMinimoEntreAportesResgatesCalculoIRAnos = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="tempoMinimoEntreAportesResgatesCalculoIRAnos"
            label={LABEL.tempoMinimoEntreAportesResgatesCalculoIRAnos}
            value={
                values.tempoMinimoEntreAportesResgatesCalculoIRAnos === 0
                    ?
                        0
                    :
                        values.tempoMinimoEntreAportesResgatesCalculoIRAnos || ''
            }
            onChange={handleChange}
            numMin={NUMMIN.tempoMinimoEntreAportesResgatesCalculoIRAnos}
            numMax={NUMMAX.tempoMinimoEntreAportesResgatesCalculoIRAnos}
        />
    )
}

export const TaxaInflacaoAnual = ({ values, handleChange }) => {
    
    return (
        <TextValidatorNumberRequired
            name="taxaInflacaoAnual"
            label={LABEL.taxaInflacaoAnual}
            value={values.taxaInflacaoAnual === 0 ? 0 : values.taxaInflacaoAnual || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
        />
    )
}

export const TaxaRetornoAnualReal = ({ values, handleChange, label }) => {

    return (
        <TextValidatorNumberRequired
            name="taxaRetornoAnualReal"
            label={label}
            value={values.taxaRetornoAnualReal === 0 ? 0 : values.taxaRetornoAnualReal || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
            disabled={true}
        />
    )
}

export const TaxaJurosAnualFgts = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="taxaJurosAnualFgts"
            label={LABEL.taxaJurosAnualFgts}
            value={values.taxaJurosAnualFgts === 0 ? 0 : values.taxaJurosAnualFgts || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
            disabled={true}
        />
    )
}

export const TaxaRetornoAnualFgtsReal = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="taxaRetornoAnualFgtsReal"
            label={LABEL.taxaRetornoAnualFgtsReal}
            value={values.taxaRetornoAnualFgtsReal === 0 ? 0 : values.taxaRetornoAnualFgtsReal || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
            disabled={true}
        />
    )
}

export const ExibirEvolucaoAporteMensalInflacao = ({ values, handleChange }) => {

    return (
        <CheckboxPadrao
            name="exibirEvolucaoAporteMensalInflacao"
            label={LABEL.exibirEvolucaoAporteMensalInflacao}
            checked={values.exibirEvolucaoAporteMensalInflacao}
            onChange={handleChange}
        />
    )
}

export const ExibirEvolucaoRetiradaMensalInflacao = ({ values, handleChange }) => {

    return (
        <CheckboxPadrao
            name="exibirEvolucaoRetiradaMensalInflacao"
            label={LABEL.exibirEvolucaoRetiradaMensalInflacao}
            checked={values.exibirEvolucaoRetiradaMensalInflacao}
            onChange={handleChange}
        />
    )
}

export const ExibirEvolucaoRecursosFinanceirosFinalInflacao = ({ values, handleChange }) => {

    return (
        <CheckboxPadrao
            name="exibirEvolucaoRecursosFinanceirosFinalInflacao"
            label={LABEL.exibirEvolucaoRecursosFinanceirosFinalInflacao}
            checked={values.exibirEvolucaoRecursosFinanceirosFinalInflacao}
            onChange={handleChange}
        />
    )
}

export const DiferenciarTaxasAposAposentadoria = ({ values, handleChange }) => {

    return (
        <CheckboxPadrao
            name="diferenciarTaxasAposAposentadoria"
            label={LABEL.diferenciarTaxasAposAposentadoria}
            checked={values.diferenciarTaxasAposAposentadoria}
            onChange={handleChange}
        />
    )
}

export const TaxaCDIAnualAposAposentadoria = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="taxaCDIAnualAposAposentadoria"
            label={LABEL.taxaCDIAnual}
            value={values.taxaCDIAnualAposAposentadoria === 0 ? 0 : values.taxaCDIAnualAposAposentadoria || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
        />
    )
}

export const RetornoCDIAposAposentadoria = ({ values, handleChange }) => {
    
    return (
        <TextValidatorNumberRequired
            name="retornoCDIAposAposentadoria"
            label={LABEL.retornoCDI}
            value={values.retornoCDIAposAposentadoria === 0 ? 0 : values.retornoCDIAposAposentadoria || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxa}
            numMax={NUMMAX.taxa}
        />
    )
}

export const TaxaJurosAnualAposAposentadoria = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="taxaJurosAnualAposAposentadoria"
            label={LABEL.taxaJurosAnual}
            value={values.taxaJurosAnualAposAposentadoria === 0 ? 0 : values.taxaJurosAnualAposAposentadoria || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
            disabled={values.taxaCDIAnualAposAposentadoria || values.retornoCDIAposAposentadoria ? true : false}
        />
    )
}

export const TaxaInflacaoAnualAposAposentadoria = ({ values, handleChange }) => {
    
    return (
        <TextValidatorNumberRequired
            name="taxaInflacaoAnualAposAposentadoria"
            label={LABEL.taxaInflacaoAnual}
            value={values.taxaInflacaoAnualAposAposentadoria === 0 ? 0 : values.taxaInflacaoAnualAposAposentadoria || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
        />
    )
}

export const TaxaRetornoAnualRealAposAposentadoria = ({ values, handleChange, label }) => {

    return (
        <TextValidatorNumberRequired
            name="taxaRetornoAnualRealAposAposentadoria"
            label={label}
            value={values.taxaRetornoAnualRealAposAposentadoria === 0 ? 0 : values.taxaRetornoAnualRealAposAposentadoria || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
            disabled={true}
        />
    )
}

export const TaxaJurosAnualFgtsAposAposentadoria = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="taxaJurosAnualFgtsAposAposentadoria"
            label={LABEL.taxaJurosAnualFgts}
            value={values.taxaJurosAnualFgtsAposAposentadoria === 0 ? 0 : values.taxaJurosAnualFgtsAposAposentadoria || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
            disabled={true}
        />
    )
}

export const TaxaRetornoAnualFgtsRealAposAposentadoria = ({ values, handleChange }) => {

    return (
        <TextValidatorNumberRequired
            name="taxaRetornoAnualFgtsRealAposAposentadoria"
            label={LABEL.taxaRetornoAnualFgtsReal}
            value={values.taxaRetornoAnualFgtsRealAposAposentadoria === 0 ? 0 : values.taxaRetornoAnualFgtsRealAposAposentadoria || ''}
            onChange={handleChange}
            numMin={NUMMIN.taxaNegativa}
            numMax={NUMMAX.taxa}
            disabled={true}
        />
    )
}